export function VariantAttributes() {
  return null;
}
